import { lazy, Suspense } from 'react'

import { SidebarType } from '../../types/Sidebar'

import { useSidebar } from '@/hooks/useSidebar'

// Lazy load components to improve initial bundle size
const Absence = lazy(() => import('./absence/Absence'))
const AbsenceEdit = lazy(() => import('./absence/AbsenceEdit'))
const BookingCreate = lazy(() => import('./booking/BookingCreate'))
const BookingEdit = lazy(() => import('./booking/BookingEdit'))
const Event = lazy(() => import('./event/Event'))
const EventEdit = lazy(() => import('./event/EventEdit'))
const FastCheckIn = lazy(() => import('./fastcheckin/FastCheckIn'))

// Loading fallback component
const SidebarLoading = () => (
  <div className="flex h-full items-center justify-center">
    <div className="text-muted-foreground">Inhalt wird geladen...</div>
  </div>
)

const Content = () => {
  const { sidebar } = useSidebar()

  if (!sidebar.open) return null

  const renderContent = () => {
    switch (sidebar.type) {
      case SidebarType.BOOKING_EDIT:
        return <BookingEdit />
      case SidebarType.BOOKING_CREATE:
        return <BookingCreate options={sidebar.options} />
      case SidebarType.ABSENCE:
        return <Absence />
      case SidebarType.ABSENCE_EDIT:
        return <AbsenceEdit absence={sidebar.absence} />
      case SidebarType.EVENT:
        return <Event />
      case SidebarType.EVENT_EDIT:
        return <EventEdit event={sidebar.event} />
      case SidebarType.FAST_CHECKIN:
        return <FastCheckIn />
      default:
        return <div className="text-destructive p-4">Unknown sidebar type</div>
    }
  }

  return <Suspense fallback={<SidebarLoading />}>{renderContent()}</Suspense>
}

export default Content
